import Config from '../config'
import fetcher from '../lib/fetcher'
import { Business } from '../lib/types'

export const getBusiness = (options?: { visitor?: number }) => {
  return fetcher<Business>(`directory/api/business/0/`)
    .setConfig(Config)
    .get({ ...options })
}
